exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".notice_dialog-notice-dialog-3NbhW{position:fixed;right:10px;width:300px;z-index:9999;overflow-y:auto}.notice_dialog-notice-dialog-3NbhW .notice_dialog-content-3oZ6r{display:block;margin:1px}", ""]);

// Exports
exports.locals = {
	"notice-dialog": "notice_dialog-notice-dialog-3NbhW",
	"content": "notice_dialog-content-3oZ6r"
};